<template>
  <v-list-tile-avatar>
    <img v-if="image" :src="image" alt="Use">
    <v-icon  v-else color="primary" size="40">account_circle</v-icon>
  </v-list-tile-avatar>
</template>

<script>
export default {

  data () {
    return {
      media: null,
      image: null
    }
  },

  mounted: function () {
    this.showImage()
  },

  methods: {
    showImage: function () {
      var self = this
      if (!this.media && this.$auth.user().media.length > 0) {
        this.$api.user.getFile({ 'id': this.$auth.user().id }, { 'preset': '80x80' }).then((response) => {
          self.image = response.data.url
        })
      }
    }
  }
}
</script>
